import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';

export function useStripePaymentId() {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async () => {
    const cardEl = elements?.getElement(CardElement);

    if (!stripe || !elements || !cardEl) {
      throw new Error('there is no stripe');
    }

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardEl,
    });

    if (error || !paymentMethod) {
      throw new Error(error?.message || 'something bad with payment');
    }

    return paymentMethod.id;
  };

  return {
    handleSubmit,
  };
}
